import React, { useEffect, useState } from 'react';
import useSOCopilotAdminPrompts from '../hooks/useSOCopilotAdmin';
import { HtmlResponseViewer } from './HtmlResponseViewer';

interface IForme {
    languageCode: string;
    feature: string;
    systemChatMessage: string;
    userChatMessage: string;
    userMessage: string;
}

const Prompts = () => {
    const [activePanel, setActivePanel] = useState<string>('PROMPTS');
    const [feature, setFeature] = useState('');
    const [resultTest, setResultTest] = useState<string>();
    const [languageCode, setLanguageCode] = useState('');
    const [extensionId, setExtensionId] = useState<string>('');
    const { plans, prompts, loading, error, sendTest, updatePrompt } = useSOCopilotAdminPrompts(
        feature,
        languageCode,
        extensionId
    );

    const [formData, setFormData] = useState<IForme>({
        languageCode: 'FR',
        feature: '',
        systemChatMessage: '',
        userChatMessage: '',
        userMessage:
            "Je suis désolé, mais il semble que vous n'avez pas fourni de message à développer. Pour que je puisse vous aider efficacement, pourriez-vous s'il vous plaît fournir le texte ou les détails spécifiques que vous souhaitez que je développe ? Cela peut inclure des informations sur le sujet que vous souhaitez aborder, des points clés que vous aimeriez voir inclus, ou tout autre détail pertinent. En ayant ces informations, je serai en mesure de mieux comprendre vos besoins et de vous fournir une réponse plus précise et utile. Merci d'avance pour votre coopération et compréhension. Pour vous donner un exemple de ce que vous pourriez inclure dans votre demande, voici quelques suggestions : 1. Le sujet principal que vous souhaitez aborder (par exemple, l'impact du changement climatique, les avantages du télétravail, etc.). 2. Les points spécifiques ou les idées principales que vous aimeriez voir développés dans le texte. 3. Tout contexte ou information supplémentaire qui pourrait m'aider à mieux comprendre votre demande (par exemple, le public cible, le format souhaité, etc.). N'hésitez pas à fournir autant de détails que possible afin que je puisse vous offrir une assistance optimale. Je suis ici pour vous aider et j'attends avec impatience votre réponse pour pouvoir commencer à travailler sur votre demande.",
    });

    const handleFeatureChange = (e) => {
        const { name, value } = e.target;
        if (name === 'feature' || name === 'languageCode') {
            setFormData({
                ...formData,
                [name]: value,
                ['systemChatMessage']: '',
                ['userChatMessage']: '',
            });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleRunTest = async () => {
        try {
            const testData = {
                languageCode: formData.languageCode,
                systemChatMessage: formData.systemChatMessage,
                userChatMessage: formData.userChatMessage,
                message: formData.userMessage,
            };
            const result = await sendTest(testData);
            setResultTest(result.text);
            console.log('Test succeeded:', result);
        } catch (err) {
            console.error('Test failed:', err.message);
        }
    };

    const handleUpdate = async () => {
        try {
            const result = await updatePrompt({
                feature: formData.feature,
                languageCode: formData.languageCode,
                systemChatMessage: formData.systemChatMessage,
                userChatMessage: formData.userChatMessage,
            });
            console.log('Update successful:', result);
        } catch (err) {
            console.error('Update failed:', err);
        }
    };

    useEffect(() => {
        if (loading.isLoading === true) setResultTest('');
    }, [loading.isLoading]);

    useEffect(() => {
        setFeature(formData.feature);
    }, [formData.feature]);

    useEffect(() => {
        setLanguageCode(formData.languageCode);
    }, [formData.languageCode]);

    useEffect(() => {
        console.log('plans:', plans);
    }, [extensionId]);

    useEffect(() => {
        if (prompts) {
            setFormData({
                ...formData,
                ['systemChatMessage']: prompts ? prompts.systemChatMessage : '',
                ['userChatMessage']: prompts ? prompts?.userChatMessage : '',
            });
        }
    }, [prompts]);

    return (
        <div>
            <div className="section" style={{ fontSize: '15px' }}>
                <div className="container">
                    {/* <h2 className="title is-4 has-text-centered">Prompts</h2> */}

                    <div
                        className="field"
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '50px',
                            alignItems: 'flex-start',
                        }}
                    >
                        <div style={{ width: '40%' }}>
                            <div
                                className="field"
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    gap: '30px',
                                    alignItems: 'center',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: '5px',
                                        alignItems: 'center',
                                    }}
                                >
                                    <div>
                                        <label className="label">Language</label>
                                    </div>
                                    <div className="control">
                                        <div className="select">
                                            <select
                                                name="languageCode"
                                                value={formData.languageCode}
                                                onChange={handleFeatureChange}
                                            >
                                                <option value="">--Select--</option>
                                                <option value="FR">FR</option>
                                                <option value="NL">NL</option>
                                                <option value="EN">EN</option>
                                                <option value="DE">DE</option>
                                                <option value="IT">IT</option>
                                                <option value="ES">ES</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        gap: '5px',
                                        alignItems: 'center',
                                    }}
                                >
                                    <div>
                                        <label className="label">Subject</label>
                                    </div>
                                    <div className="control">
                                        <div className="select">
                                            <select
                                                name="feature"
                                                value={formData.feature}
                                                onChange={handleFeatureChange}
                                            >
                                                <option value="">--Select--</option>
                                                <option value="ImproveWriting">Improve Writing</option>
                                                <option value="ReduceText">Reduce Text</option>
                                                <option value="DevelopText">Develop Text</option>
                                                <option value="TranslateText">Translate Text</option>
                                                <option value="CorrectText">Correct Text</option>
                                                <option value="FormatAsHTML">Format as HTML</option>
                                                <option value="SimplifyLanguage">Simplify Language</option>
                                                <option value="ExplainText">Explain Text</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="field">
                                <label className="label">System Message (prompt)</label>
                                <div className="control">
                                    <textarea
                                        style={{ minHeight: '250px' }}
                                        name="systemChatMessage"
                                        value={formData.systemChatMessage}
                                        className="textarea"
                                        placeholder="System Chat Message"
                                        onChange={handleFeatureChange}
                                    />
                                </div>
                            </div>

                            <div className="field">
                                <label className="label">
                                    "Prefix" (Optional, concatenate to the beginning of the User Message)
                                </label>
                                <div className="control">
                                    <textarea
                                        style={{ minHeight: '100px' }}
                                        name="userChatMessage"
                                        value={formData.userChatMessage}
                                        className="textarea"
                                        placeholder="Prefix"
                                        onChange={handleFeatureChange}
                                    />
                                </div>
                            </div>

                            <div className="field is-grouped h-center">
                                <div className="control">
                                    <button className="button is-success" onClick={handleUpdate}>
                                        Save
                                    </button>
                                    <button className="button is-light">Cancel</button>
                                </div>
                                <div className="ml-auto"></div>
                                <div className="control">
                                    <button className="button is-primary is-outlined" onClick={handleRunTest}>
                                        Test
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div style={{ width: '60%' }}>
                            <div className="field">
                                <label className="label">User Message (example)</label>
                                <div className="control">
                                    <textarea
                                        name="userMessage"
                                        style={{ height: '450px' }}
                                        value={formData.userMessage}
                                        className="textarea"
                                        placeholder="User Chat Message"
                                        onChange={handleFeatureChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="section grey no-shadow">
                {loading && loading.isLoading === true && <div className="h-center">{loading.message}</div>}
                {error && <p style={{ color: 'red' }}>Erreur : {error}</p>}

                {resultTest && <HtmlResponseViewer htmlContent={resultTest} />}
            </div>
        </div>
    );
};

export default Prompts;
